;(() => {
  if (window.__lilacSubPurchaseTabsScript) return
  window.__lilacSubPurchaseTabsScript = true

  const STORAGE_KEY = 'lilacSubPurchaseTab'
  const TABS_SELECTOR = '.sub-purchase-tabs'

  if (!window.__lilacSubPurchaseTabsBooted) {
    window.__lilacSubPurchaseTabsBooted = true
    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      /* ignore */
    }
  }

  function getSavedTab() {
    try {
      const value = sessionStorage.getItem(STORAGE_KEY)
      return value === 'one-time' || value === 'subscription' ? value : null
    } catch (e) {
      return null
    }
  }

  function saveTab(value) {
    if (value !== 'one-time' && value !== 'subscription') return
    try {
      sessionStorage.setItem(STORAGE_KEY, value)
    } catch (e) {
      /* ignore */
    }
  }

  function applyPurchaseTab(root, tab, { emitChange = false } = {}) {
    if (!root || (tab !== 'one-time' && tab !== 'subscription')) return

    const dskRadios = root.querySelectorAll('[data-deluxe-purchase-option]')
    if (dskRadios.length) {
      let checkedRadio = null
      dskRadios.forEach((radio) => {
        const selected = radio.value === tab
        radio.checked = selected
        radio.closest('[data-deluxe-purchase-card]')?.classList.toggle('is-active', selected)
        if (selected) checkedRadio = radio
      })

      const widget = root.closest('[data-dsk-widget]') || root.parentElement
      const showSubscription = tab === 'subscription'
      widget?.querySelector('[data-deluxe-frequency-wrapper]')?.classList.toggle('hidden', !showSubscription)
      widget?.querySelector('[data-dsk-subscriber-benefits]')?.classList.toggle('hidden', !showSubscription)
      widget?.querySelector('[data-subscription-reward-widget]')?.classList.toggle('hidden', !showSubscription)

      if (emitChange && checkedRadio) {
        checkedRadio.dispatchEvent(new Event('change', { bubbles: true }))
      }
      return
    }

    root.querySelectorAll('[data-tab]').forEach((button) => {
      button.classList.toggle('active', button.getAttribute('data-tab') === tab)
    })

    const shell = root.closest('.lash-bundle-option-container') || root.parentElement
    const subscriptionContent = shell?.querySelector('#subscription-content')
    const oneTimeContent = shell?.querySelector('#one-time-content')
    if (subscriptionContent) subscriptionContent.classList.toggle('hidden', tab !== 'subscription')
    if (oneTimeContent) oneTimeContent.classList.toggle('hidden', tab !== 'one-time')
  }

  function restoreAll({ emitChange = false } = {}) {
    const tab = getSavedTab()
    if (!tab) return
    document.querySelectorAll(TABS_SELECTOR).forEach((root) => {
      applyPurchaseTab(root, tab, { emitChange })
    })
  }

  function restoreSoon({ emitChange = false } = {}) {
    requestAnimationFrame(() => restoreAll({ emitChange }))
    window.setTimeout(() => restoreAll({ emitChange }), 50)
  }

  window.lilacGetSubPurchaseTab = getSavedTab
  window.lilacApplySubPurchaseTab = applyPurchaseTab
  window.lilacRestoreSubPurchaseTabs = restoreAll

  document.addEventListener('click', (event) => {
    const button = event.target.closest(`${TABS_SELECTOR} [data-tab]`)
    if (!button) return
    saveTab(button.getAttribute('data-tab'))
  })

  document.addEventListener('change', (event) => {
    const target = event.target
    if (!(target instanceof Element)) return

    if (target.matches('[data-deluxe-purchase-option]')) {
      saveTab(target.value)
      return
    }

    if (target.matches('[data-hook="product-option"], [data-product-selector], select[id^="lash"]')) {
      restoreSoon({ emitChange: true })
    }
  })

  function subscribeTabText(variant, fallback) {
    const raw = variant?.metafields?.custom?.text_for_subscribe_option
    const value = raw && typeof raw === 'object' && raw.value != null ? raw.value : raw
    const text = value == null ? '' : String(value).trim()
    return text || fallback || ''
  }

  document.addEventListener('product:variant:change', (event) => {
    const variant = event.detail?.variant
    if (variant) {
      document.querySelectorAll('[data-subscribe-tab-subtitle]').forEach((element) => {
        const fallback = element.getAttribute('data-subscribe-tab-fallback') || ''
        const text = subscribeTabText(variant, fallback)
        element.hidden = !text
        element.textContent = text
      })
    }
    restoreSoon()
  })

  document.addEventListener('product:collection:change', () => {
    restoreSoon({ emitChange: true })
  })

  const observer = new MutationObserver((mutations) => {
    const hasNewTabs = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false
        return node.matches?.(TABS_SELECTOR) || node.querySelector?.(TABS_SELECTOR)
      })
    )
    if (hasNewTabs) restoreAll({ emitChange: true })
  })

  const startObserver = () => {
    if (!document.body) return
    observer.observe(document.body, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true })
  } else {
    startObserver()
  }
})()
